<template>
    <div>
        <v-row class="justify-center  align-center mt-8">
            <v-select
                v-model="selected_tag"
                :items="$store.state.tags"
                label="曲のタグを選択"
                clearable
                class="shrink"
            ></v-select>
        </v-row>
        <v-row class="justify-center  align-center mt-4">
            <v-data-table
                :headers="headers"
                :items="items"
            >
                <template v-slot:item.ranking="{ item }">
                    {{ getRankingNum(item) }}
                </template>
                <template v-slot:item.score="{ item }">
                    <v-chip
                        :color="getColor(item.score)"
                        dark
                    >
                        {{ item.score }}
                    </v-chip>
                </template>
                <template v-slot:item.user="{ item }">
                    <span v-if="(item.user==$store.state.username)" style="color: red;">{{ item.user }}</span>
                    <span v-else>{{ item.user }}</span>
                </template>
                <template v-slot:item.play="{ item }">
                    <audio controls preload="none">
                        <source :src="'https://devpsa2161052-dev.s3-ap-northeast-1.amazonaws.com/public/' + item.user + '/' + item.file_id + '.mp3'">
                    </audio>
                </template>
            </v-data-table>
        </v-row>

    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: "RankingComponent",
    data(){
        return {
            selected_tag: null,
            items:[],
            headers: [
                {
                    text:"順位",
                    value:'ranking',
                    sortable:false
                },
                {
                    text:"Score",
                    value: "score",
                    sortable:false
                },
                {
                    text:"ユーザー",
                    value: "user",
                    sortable:false
                },
                {
                    text:'再生',
                    value:'play',
                    sortable:false
                }
            ]
        }
    },
    watch:{
        selected_tag: function(newVal){
            this.items = [];
            const apiUrl = "https://flhrsaddm1.execute-api.ap-northeast-1.amazonaws.com/dev/getranking";
            // apiへの送信情報を定義
            const post_data = {
                tag : newVal
            }; 
            const headers = {
                headers: {
                    "Content-Type": "application/json"
                }
            } 
            // POST送信
            const _this = this;
            axios.post(apiUrl,post_data,headers)
            .then((res) => {
                _this.items = res.data.Items;
            })
            .catch((err) => {
                console.log(err);
            })            
        }
    },
    methods:{
        getColor (score) {
            if (score > 90) return 'red'
            else if (score > 80) return 'orange'
            else return 'green'
        },
        getRankingNum(item){
            let index = this.items.indexOf( item ) + 1;
            return index
        },
        test(){
            var audio = document.getElementById("audio");
            audio.pause()
        }
    }
};

</script>

<style scoped>
table {
    margin-left: auto;
    margin-right: auto;
    margin-top: 3%;
    width: 50%;
}
.active {
    color: red;
}
</style>